import { formatHour, formatMinutes, minutesToOffset } from "./calendarLayout";
import { GUTTER_WIDTH } from "./constants";
import classes from "./SessionsCalendar.module.css";

/** The hour scale down the left edge, plus the current time on today. */
export default function TimeGutter({
  startHour,
  endHour,
  height,
  nowMinutes,
  nowTop,
}) {
  const hours = Array.from(
    { length: endHour - startHour + 1 },
    (_, index) => startHour + index
  );

  return (
    <div className={classes.gutterCell} style={{ height, width: GUTTER_WIDTH }}>
      {hours.map((hour) => (
        <div
          key={hour}
          className={classes.hourLabel}
          style={{
            top: minutesToOffset((hour - startHour) * 60),
            // The outermost labels tuck inside the grid instead of straddling
            // its top and bottom edges
            transform:
              hour === startHour
                ? "translateY(0)"
                : hour === endHour
                  ? "translateY(-100%)"
                  : "translateY(-50%)",
          }}
        >
          {formatHour(hour)}
        </div>
      ))}
      {nowMinutes !== null && (
        <div className={classes.nowLabel} style={{ top: nowTop }}>
          {formatMinutes(nowMinutes)}
        </div>
      )}
    </div>
  );
}
